angular.module('balanceBmPoint', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/balance-bm-point/balance-bm-point.module.js